import './App.css';
import Header from "./components/Header/Header";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-quill/dist/quill.snow.css';

import {Route, Switch, useHistory, useLocation } from "react-router-dom";
import React from "react";
import Main from "./components/Main/Main";
import Footer from "./components/Footer/Footer";
import Articles from "./components/Articles/Articles";
import AdminRoutes from "./admin/AdminRoutes";
import Search from "./components/Search/Search";
import ArticleContainer from "./components/Articles/Article/ArticleContainer";
import JournalsContainer from "./components/Journals/JournalsContainer";
import ReleasesContainer from "./components/Journals/ReleasesContainer";
import Institute from "./components/Education/Institute";
import Department from "./components/Education/Department";
import EduAuthors from "./components/Education/EduAuthors";
import EducationInfo from "./components/Education/EducationInfo";
import EducationContainer from "./components/Education/EducationContainer";
import EduWithDepartContainer from "./components/Education/EduWithDepartContainer";
import EduOneAuthor from "./components/Education/EduOneAuthor";
import Pdf from "./components/PdfView/Pdf";
import getCookie from "./utils/customFunctions";
import {Worker} from "@react-pdf-viewer/core";
import { Profspo } from 'components/Profspo';
import { IprSmart } from 'components/IprSmart';
import { useEffect } from 'react';
import DisertationAuthors from 'components/Disertation/DisertationAuthors';
import Napravlenie from 'components/Disertation/Napravlenie';
import Spec from 'components/Disertation/Spec';
import DisertationsContainer from 'components/Disertation/DisertationsContainer';
import Disertation from 'components/Disertation/Disertation';
import DisertationOneAuthor from 'components/Disertation/DisertationOneAuthor';



function App() {

    let location = useLocation();
    let history = useHistory();
    useEffect(()=>{

        if(!getCookie('token') &&
            !localStorage.getItem('token') &&
            !history.location.pathname.toLowerCase().includes('admin')
        ){
            alert('Пожалуйста, пройдите авторизацию')
            window.location = 'https://isu.gstou.ru/'
        }


    },[])

    useEffect(() => {
       window.scrollTo({left:0, top: 0, behavior: 'smooth'})
    }, [location.pathname])
    

    return (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/legacy/build/pdf.worker.js">

        <Switch>
            {/* Админка живёт вне обёртки .App: у неё своя шапка и сайдбар, шапка с
                футером публичного сайта вокруг неё только мешали. Заодно снимается
                конфликт стилей — правило `.App a { color: #b92034 }` в App.css
                специфичнее односоставных классов админки и перекрашивало её ссылки
                и кнопки (текст на красной кнопке совпадал с фоном). */}
            <Route path='/admin' render={() => <AdminRoutes/>}/>

            <Route render={() => (
        <div className="App">
            <Header/>
            {/*<Breadcrumd/>*/}
            <div className="body-section">
                <Switch>
                    <Route exact path='/'
                           render={() => <Main/>}/>
                    <Route path='/результатпоиска/:search/:sect'
                           render={() => <Search/>}/>
                    <Route path='/журнал/статья/:id?'
                           render={() => <ArticleContainer/>}/>
                    <Route path='/журналы'
                           render={() => <JournalsContainer/>}/>
                    <Route path='/релизы/:id?'
                           render={() => <ReleasesContainer/>}/>
                    <Route path='/документ/:id?/:name/:isDisertation?'
                           render={() => <Pdf />}/>


                    <Route path='/статьи'
                           render={() => <Articles page={'article'}/>}/>
                    <Route path='/авторы'
                           render={() => <Articles page={'author'}/>}/>
                    <Route path='/ключевыеслова'
                           render={() => <Articles page={'keyword'}/>}/>
                    <Route path='/автор/:id?'
                           render={() => <Articles page={'authorid'}/>}/>
                    <Route path='/хештег/:id?'
                           render={() => <Articles page={'keywordid'}/>}/>


                    {/*Учебно-методические пособия*/}

                    <Route path='/учебныеиздания/авторы'
                           render={() => <EduAuthors/>}/>
                    <Route path='/учебныеиздания/автор/:id'
                           render={() => <EduOneAuthor/>}/>
                    <Route path='/учебныеиздания/институты'
                           render={() => <Institute/>}/>
                    <Route path='/учебныеиздания/кафедры/:id'
                           render={() => <Department/>}/>
                    <Route path='/учебныеиздания/кафедра/:id'
                           render={() => <EduWithDepartContainer/>}/>
                    <Route path='/учебныеиздания/учебник/:id'
                           render={() => <EducationInfo/>}/>
                    <Route path='/учебныеиздания/'
                           render={() => <EducationContainer/>}/>

                     
                     {/*Диссертации*/}
                     <Route path='/диссертации/авторы'
                           render={() => <DisertationAuthors/>}/>
                     <Route path='/диссертации/автор/:id'
                           render={() => <DisertationOneAuthor/>}/>
                     <Route path='/диссертации/направления'
                            render={() => <Napravlenie/>}/>
                     <Route path='/диссертации/специальность/:id'
                            render={() => <Spec/>}/>
                     <Route path='/диссертация/:id'
                             render={() => <Disertation/>}/>
                     <Route path='/диссертации/:id'
                             render={() => <DisertationsContainer/>}/>

                     {/*Профобразование */}
                    <Route path='/profspo'
                           render={() => <Profspo/>}/>

                     {/*IprSmart */}
                    <Route path='/iprsmart'
                           render={() => <IprSmart/>}/>


                    <Route path='*'
                           render={() => <div>404 Страница не найдена</div>}/>


                </Switch>
            </div>
            <Footer/>
        </div>
            )}/>
        </Switch>
        </Worker>
    );
}

export default App;
